import React, { useState, useEffect } from "react";
import "./Navbar.css";
import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import { NavBarContainer, NavLogoLink, NavBarWrapper, MenuIconBar, NavLink, NavItemList, NavBtn, BtnLink, NavItem } from "./Navbar.style";

interface HeaderProps {}

export const Navbar: React.FC<HeaderProps> = () => {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [colorChange, setColorchange] = useState(false);


  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const changeNavbarColor = () =>{
     if(window.scrollY >= 80){
       setColorchange(true);
     }
     else{
       setColorchange(false);
     }
  };

  window.addEventListener('scroll', changeNavbarColor);
  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
    window.addEventListener("resize", showButton);
  }, []);
 

  return (
    <>
        <NavBarWrapper className={colorChange ? 'colorChange' : 'navbar'}>
          <div className="container">
            <NavLogoLink to="/" onClick={closeMobileMenu}>
              <img
                // src="img/Rectangle 697.svg"
                src="img/Bonpellz Logo (PNG) 1.png"
                // style={{height:"50px"}}
                alt="bonpellz logo"
                // className="logo  w-[52px] h-[52px]"
              />
            </NavLogoLink>
            <MenuIconBar onClick={handleClick}>
              {click ? (
                <ClearIcon style={{ color: "black" }} />
              ) : (
                <MenuIcon style={{ color: "black" }} />
              )}
            </MenuIconBar>
            <NavItemList className={click ? "nav-menu active" : "nav-menu"}>




        
    
     

                <NavLink
                  to="/"
                  onClick={closeMobileMenu}
                >
                  Home
                </NavLink>
                <NavLink
                  to="/coming-soon"
                  onClick={closeMobileMenu}
                >
                   Create SP PIN
                </NavLink>
                <NavLink to="/coming-soon"
                 onClick={closeMobileMenu}>
                  Sign up
                </NavLink>
                <NavLink
                  to="/faqs"
                  onClick={closeMobileMenu}
                >
                  FAQs
                </NavLink>
                <NavLink
                  to="/about"
                  onClick={closeMobileMenu}
                >
                  About Us
                </NavLink>
       



              {/* <NavItem>
                <NavLink
                  to="/"
                  onClick={closeMobileMenu}
                >
                  Home
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/create-sp"
                  onClick={closeMobileMenu}
                >
                   Create SP PIN
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/sign-up"
                 onClick={closeMobileMenu}>
                  sign up
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/cid"
                  onClick={closeMobileMenu}
                >
                  CID
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/faqs"
                  onClick={closeMobileMenu}
                >
                  FAQS
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/about"
                  onClick={closeMobileMenu}
                >
                  About Us
                </NavLink>
              </NavItem> */}
             


             <NavBtn>
                <BtnLink 
                  onClick={closeMobileMenu}
                  to="/earlyaccess">
                    Get early Access
                </BtnLink>
            </NavBtn>
              
            </NavItemList>
        
           
          </div>
        </NavBarWrapper>
    </>
  );
};

;
